export default "__VITE_ASSET__NB9roMrs__"